import {
  BackboneView,
} from '@/views';

/* Estas rutas son las antiguas que habian antes en la aplicación
* que pueden estar en un enlace externo de la web
*/

const routes = {
  privatePaths: [
    {
      path: '/catalog/R/:catalog?/:catalog_category?/:category?/:element?/:elementid?',
      redirect: (to) => (
        { path: to?.params?.elementid ? `/element/r/${to.params.elementid.replace(/^U'(.*)'$/, '$1')}` : `/request/${to?.params?.category ? to.params.category.replace(/^U'(.*)'$/, '$1') : ''}` }
      ),
    },
    // Enlace de compartir una peticion de catalogo o Problema.
    // No habia enlaces de compartir en Incidencias
    {
      path: '/element/:elementid',
      redirect: (to) => (
        { path: to.params.elementid === 'P' ? '/problem' : `/element/r/${to.params.elementid.replace(/^U'(.*)'$/, '$1')}` }
      ),
    },
    {
      path: '/catalog/I/:catalog?/:catalog_category?/:category?/:element?/:elementid?',
      redirect: (to) => (
        { path: to?.params?.elementid ? `/element/i/${to.params.elementid.replace(/^U'(.*)'$/, '$1')}` : '/incident/' }
      ),
    },
    {
      path: '/kb/documents/:id',
      redirect: (to) => (
        { path: `/knowledge-items/${to.params.id}` }
      ),
    },

  ],
  publicPaths: [
    {
      path: 'notifs',
      component: BackboneView,
      props: () => ({
        dispatchReadyOnMount: true,
      }),
    },
    {
      path: '/public/kb/:id',
      redirect: (to) => (
        { path: `/public/knowledge-items/${to.params.id}` }
      ),
    },
  ],
};
export default routes;
